import { render, staticRenderFns } from "./company-type-widget.vue?vue&type=template&id=65cd8e48&"
import script from "./company-type-widget.vue?vue&type=script&lang=js&"
export * from "./company-type-widget.vue?vue&type=script&lang=js&"
import style0 from "./company-type-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports